import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoPivotGridMixin from './KendoPivotGridMixin'

export default {
    name: 'kendo-pivotgrid',
    mixins: [ KendoPivotGridMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('div', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotGrid/index.js